var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 346,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#5E9CC4",
    d: "m132.47875,257.40399c0,0 -11.79945,6.86179 8.39726,9.18374c24.46774,2.79132 36.97292,2.39101 63.93653,-2.71226c0,0 7.08899,4.44498 16.98926,8.2949c-60.4453,25.90584 -136.79962,-1.50051 -89.32305,-14.76637"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#5E9CC4",
    d: "m125.09266,223.59857c0,0 -13.23422,9.79625 6.97747,11.88683c26.13721,2.69645 46.77832,2.91699 82.4954,-3.96061c0,0 4.94014,5.00839 12.70824,7.74728c-73.08197,21.37015 -154.48214,1.68528 -102.1811,-15.6735"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "#E76F00",
    d: "m187.35973,166.25334c14.8937,17.1474 -3.91318,32.57788 -3.91318,32.57788c0,0 37.81763,-19.52258 20.44971,-43.96952c-16.22111,-22.79827 -28.66053,-34.12584 38.68149,-73.18184c0,0 -105.70478,26.40019 -55.21801,84.57348"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "#5E9CC4",
    d: "m267.30347,282.40852c0,0 8.73182,7.19468 -9.61648,12.76067c-34.88982,10.56939 -145.21519,13.76102 -175.86311,0.42111c-11.01715,-4.79285 9.64311,-11.44408 16.14205,-12.83974c6.77773,-1.46973 10.65095,-1.19592 10.65095,-1.19592c-12.25217,-8.63112 -79.19307,16.94765 -34.00267,24.27299c123.24082,19.98615 224.65627,-8.9998 192.68925,-23.41912"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#5E9CC4",
    d: "m138.15294,188.57226c0,0 -56.1185,13.32908 -19.87296,18.16937c15.30399,2.04897 45.81209,1.58542 74.22962,-0.79562c23.22437,-1.95909 46.54446,-6.12442 46.54446,-6.12442c0,0 -8.1892,3.50704 -14.11389,7.55254c-56.98736,14.98775 -167.07636,8.01527 -135.38316,-7.31536c26.80299,-12.95624 48.59593,-11.48651 48.59593,-11.48651"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    fill: "#5E9CC4",
    d: "m238.82269,244.84305c57.93028,-30.10281 31.14561,-59.03133 12.45025,-55.13397c-4.58229,0.95375 -6.62542,1.78015 -6.62542,1.78015c0,0 1.70109,-2.66481 4.95013,-3.8183c36.9854,-13.00286 65.42956,38.35027 -11.93926,58.68929c0,0.00083 0.89632,-0.8006 1.1643,-1.51717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    fill: "#E76F00",
    d: "m203.89624,18.61469c0,0 32.0827,32.09352 -30.42904,81.44428c-50.12807,39.5878 -11.43076,62.15971 -0.02081,87.94903c-29.26058,-26.40019 -50.73393,-49.64039 -36.32793,-71.27019c21.14462,-31.75064 79.72238,-47.14451 66.77778,-98.12312"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    fill: "#5E9CC4",
    d: "m143.84543,326.41466c55.60584,3.55947 140.99491,-1.9749 143.01725,-28.28604c0,0 -3.88738,9.97434 -45.95524,17.89557c-47.46075,8.93155 -105.99689,7.88876 -140.71529,2.16464c0.00083,-0.00083 7.10729,5.88225 43.65327,8.22582"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.20e6e1de4fb41af747d68c94cabbe015.svg";
export { ForwardRef as ReactComponent };